// CSS Modules - component class name prefix: ShopStartPage__

<template>
  <div :class="$style.container">
    <ShopPageHeader />
    <HeroSlider :slides="slides" />
    <div :class="[$style.contentGrid, $style.firstGrid, 'columns']">
      <div :class="[$style.flexColumn, 'column is-two-thirds']">
        <h2>Lorem Ipsum</h2>
        <BigNavButtons />
      </div>
      <div :class="[$style.flexColumn, 'column is-one-third']">
        <h2>Lorem Ipsum</h2>
        <QuickAddBox :config="quickAddConfig" />
      </div>
    </div>
    <div :class="$style.contentGrid">
      <h2>Lorem Ipsum</h2>
      <ShopProductList />
    </div>
    <div :class="$style.contentGrid">
      <h2>Lorem Ipsum</h2>
      <ShopProductList :isBestSellers="false" />
    </div>
    <ShopFooter />
    <CookieDisclaimer :config="cookieDisclaimerConfig" />
  </div>
</template>

<script>
import BigNavButtons from "../BigNavButtons/BigNavButtons.vue";
import ShopProductList from "../ShopProductList/ShopProductList.vue";
import ShopFooter from "../ShopFooter/ShopFooter.vue";
import HeroSlider from "../HeroSlider/HeroSlider.vue";
import ShopPageHeader from "../ShopPageHeader/ShopPageHeader.vue";
import QuickAddBox from "../QuickAddBox/QuickAddBox.vue";
import CookieDisclaimer from "../CookieDisclaimer/CookieDisclaimer.vue";

export default {
  name: "ShopStartPage",
  components: {
    BigNavButtons,
    ShopProductList,
    ShopFooter,
    HeroSlider,
    ShopPageHeader,
    QuickAddBox,
    CookieDisclaimer
  },
  props: {
    slides: undefined,
    cookieDisclaimerConfig: undefined,
    quickAddConfig: undefined
  }
};
</script>

<style module lang="scss">
@import "./ShopStartPage.scss";
</style>
